<template>
	<b-card title="Audio" class="mb-3">
		<volume-slider v-model="settings.volume" />
	</b-card>
</template>

<script>
import VolumeSlider from '@/components/VolumeSlider.vue';

export default {
	components: { VolumeSlider },
	props: {
		settings: Object,
	},
};
</script>
